import Portal = require("portal-gis");

function renderItem(item: Portal.MapLayerLeaf) {
    return `<option value="${item.id}">${item.text}</option>`;
}

function renderItems(data: { items: Portal.MapLayerLeaf[] }) {
    return data.items.filter(d => d.basemap && !d.disabled).map(renderItem).join("");
}

export = renderItems;
